import React, { useEffect, useState } from 'react';
import './Information.css';
import Lottie from 'lottie-react';
import weatherAnimation from '../json-lottie/Sunny.json';
import dresscodeAnimation from '../json-lottie/Neck Tie.json';
import nokidsAnimation from '../json-lottie/Moon Walk.json';
import { useLanguage } from '../context/LanguageContext';

function Information() {
  const { t } = useLanguage();
  const [weather, setWeather] = useState(null);
  const [currentCardIndex, setCurrentCardIndex] = useState(0);
  const cardContainerRef = React.useRef(null);

  const scrollToCard = (index) => {
    if (cardContainerRef.current) {
      const cards = cardContainerRef.current.querySelectorAll('.cards-info');
      if (cards[index]) {
        cards[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        setCurrentCardIndex(index);
      }
    }
  };

  // Track which card is in view
  useEffect(() => {
    if (!cardContainerRef.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
            const cards = Array.from(cardContainerRef.current.querySelectorAll('.cards-info'));
            const index = cards.indexOf(entry.target);
            if (index !== -1) {
              setCurrentCardIndex(index);
            }
          }
        });
      },
      { threshold: 0.5, root: cardContainerRef.current }
    );

    const cards = cardContainerRef.current.querySelectorAll('.cards-info');
    cards.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  const capitalizeWords = (str) => {
    return str.split(' ').map(word =>
      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    ).join(' ');
  };

  useEffect(() => {
    const fetchWeather = async () => {
      const apiKey = '4f9abfd2fd36674163d3739f268105e0'; // Replace with your OpenWeatherMap key
      const city = 'Mexico City'; // Replace with your desired city
      const langMap = {
        'es': 'es',
        'en': 'en',
        'fr': 'fr'
      };
      const apiLang = langMap[t.lang] || 'es'; // Default to Spanish if undefined
      const url = `https://api.openweathermap.org/data/2.5/weather?q=${city}&units=metric&lang=${apiLang}&appid=${apiKey}`;

      try {
        const response = await fetch(url);
        const data = await response.json();

        if (response.ok) {
          setWeather(data);
        } else {
          console.error('Error fetching weather data:', data.message);
        }
      } catch (error) {
        console.error('Network error:', error);
      }
    };

    fetchWeather();
  }, [t.lang]);

  console.log(weather); // Debugging: Check the weather data

  return (
    <div className='information'>
      <h2>{t.information_title}</h2>

      <div className="card-container-info" ref={cardContainerRef}>
        {/* Navigation Arrows */}
        {currentCardIndex > 0 && (
          <button
            className="nav-arrow left"
            onClick={() => scrollToCard(currentCardIndex - 1)}
            aria-label="Previous card"
          >
            &#10094;
          </button>
        )}

        {currentCardIndex < 2 && (
          <button
            className="nav-arrow right"
            onClick={() => scrollToCard(currentCardIndex + 1)}
            aria-label="Next card"
          >
            &#10095;
          </button>
        )}

        {/* Weather Card */}
        <div className="cards-info">
          <div className="card-title">{t.information_weather_title}</div>
          <Lottie animationData={weatherAnimation} style={{ width: 190, height: 120 }} />
          {weather && weather.main && weather.weather ? (
            <>
              <p className="card-time">{Math.round(weather.main.temp)}°C</p>
              <h1 className="card-header1">{weather.name === 'Mexico City' ? t.information_weather : weather.name}</h1>
              <h3 className="card-header2">{capitalizeWords(weather.weather[0].description)}</h3>
            </>
          ) : (
            <p className="card-header2">Cargando clima...</p>
          )}
        </div>

        {/* Dress Code Card */}
        <div className="cards-info">
          <div className="card-title">{t.information_dresscode_title}</div>
          <Lottie animationData={dresscodeAnimation} style={{ width: 190, height: 120 }} />
          <p className="card-time">{t.information_dresscode_type}</p>
          <h1 className="card-header1">{t.information_dresscode_colors}</h1>
          <h3 className="card-header2"><span className="bold-text">{t.information_dresscode_men}</span> {t.information_dresscode_men2} <span className="bold-text">{t.information_dresscode_women}</span> {t.information_dresscode_women2}</h3>
        </div>

        {/* Gift Card */}
        <div className="cards-info">
          <div className="card-title">{t.information_nokids_title}</div>
          <Lottie animationData={nokidsAnimation} style={{ width: 190, height: 120 }} />
          <h1 className="card-header1">{t.information_nokids_text}</h1>
          <h3 className="card-header2">{t.information_nokids_text2}</h3>
        </div>
      </div>
    </div>
  );
}


export default Information;